import { render, staticRenderFns } from "./MinimumOrderAmount.vue?vue&type=template&id=c9564850&scoped=true"
import script from "./MinimumOrderAmount.vue?vue&type=script&lang=js"
export * from "./MinimumOrderAmount.vue?vue&type=script&lang=js"
import style0 from "./MinimumOrderAmount.vue?vue&type=style&index=0&id=c9564850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9564850",
  null
  
)

export default component.exports